import * as React from "react";
import { IInvestigatorInPlay, PlayerComponent } from "./Scenario";
import { InvestigatorHandComponent } from "./InvestigatorHand";
import { DeckComponent } from "./DeckComponent";
import { CardType, ICard } from "./Card";
import { IDropTarget, Dnd, IDrop } from "./Dnd";
import { DeckUtil } from "./DeckUtil";

export interface IPlayerNavigatorProps {
    state: IInvestigatorInPlay;
    onChanged: () => void;
}

export interface IPlayerNavigatorMenuItemProps {
    state: IInvestigatorInPlay;
    playerComponent: PlayerComponent;
    title: string;
    onChanged: () => void;
}
export class PlayerNavigatorMenuItemComponent extends React.Component<IPlayerNavigatorMenuItemProps, any> implements IDropTarget {
    allowDrop(dragType: string, effectAllowed: string): string {
        switch (this.props.playerComponent) {
            case PlayerComponent.InPlay:
                if (dragType === "card/" + (CardType[CardType.Asset]).toLowerCase()) {
                    return Dnd.move;
                }
                break;
            case PlayerComponent.Deck:
                if (/^card\/.+/.test(dragType)) {
                    return Dnd.move;
                }
                break;
            case PlayerComponent.Hand:
                if (/^card\/.+/.test(dragType)) {
                    return Dnd.move;
                }
                break;
            case PlayerComponent.Discard:
                if (/^card\/.+/.test(dragType)) {
                    return Dnd.move;
                }
                break;
            case PlayerComponent.Threat:
                if (/^card\/.+/.test(dragType)) {
                    return Dnd.move;
                }
                break;
        }
        return null;
    }
    onDrop(drop: IDrop): boolean {
        const card = drop.value as ICard;
        switch (this.props.playerComponent) {
            case PlayerComponent.InPlay:
                if (!card) return false;
                if (!this.props.state.inPlay)
                    this.props.state.inPlay = { cards: [] };
                this.props.state.inPlay.cards.push(card);
                this.props.onChanged();
                return true;
            case PlayerComponent.Hand:
                if (!card) return false;
                card.faceUp = true;
                if (!this.props.state.hand)
                    this.props.state.hand = { cards: [] };
                DeckUtil.addToTop(this.props.state.hand, card);
                this.props.onChanged();
                return true;
            case PlayerComponent.Discard:
                if (!card) return false;
                card.faceUp = true;
                card.tokens = [];
                if (!this.props.state.discard)
                    this.props.state.discard = { cards: [] };
                DeckUtil.addToTop(this.props.state.discard, card);
                this.props.onChanged();
                return true;
            case PlayerComponent.Threat:
                if (!card) return false;
                if (!this.props.state.threat)
                    this.props.state.threat = { cards: [] };
                this.props.state.threat.cards.push(card);
                this.props.onChanged();
                return true;
            case PlayerComponent.Deck:
                if (!card) return false;
                card.faceUp = false;
                if (!this.props.state.deck)
                    this.props.state.deck = { cards: [] };
                DeckUtil.add(this.props.state.deck, card);
                this.props.onChanged();
                return true;
        }
        return false;
    }
    getNoOfItems() {
        const inv = this.props.state;
        switch (this.props.playerComponent) {
            case PlayerComponent.InPlay:
                if (!inv.inPlay || !inv.inPlay.cards) return 0;
                return inv.inPlay.cards.length;
            case PlayerComponent.Hand:
                if (!inv.hand || !inv.hand.cards) return 0;
                return inv.hand.cards.length;
            case PlayerComponent.Discard:
                if (!inv.discard || !inv.discard.cards) return 0;
                return inv.discard.cards.length;
            case PlayerComponent.Threat:
                if (!inv.threat || !inv.threat.cards) return 0;
                return inv.threat.cards.length;
            case PlayerComponent.Deck:
                if (!inv.deck || !inv.deck.cards) return 0;
                return inv.deck.cards.length;
        }
        return 0;
    }
    setActiveComponent() {
        this.props.state.activeComponent = this.props.playerComponent;
        this.props.onChanged();
    }
    render() {
        let className = "";
        if (this.props.state.activeComponent === this.props.playerComponent) {
            className = "active";
        }
        return (<li className={className}
            onClick={() => { this.setActiveComponent(); }}
            onDragOver={(e) => Dnd.dragOver(e, this)}
            onDrop={(e) => Dnd.drop(e, this)}
        >{this.props.title} ({this.getNoOfItems()})</li>);
    }
}
export class PlayerNavigatorComponent extends React.Component<IPlayerNavigatorProps, any>  {

    pickOneCardFromDeckToHand(): void {
        var card = DeckUtil.removeTopCard(this.props.state.deck);
        if (!card) {
            alert("No card in deck");
            return;
        }
        if (!this.props.state.hand)
            this.props.state.hand = { cards: [] };
        DeckUtil.add(this.props.state.hand, card);
        this.props.onChanged();
    }
    render() {

        let component: JSX.Element = null;
        switch (this.props.state.activeComponent) {
            case PlayerComponent.Hand:
                component = <InvestigatorHandComponent key={1} deck={this.props.state.hand} onChanged={() => this.props.onChanged()}
                    settings={{ toolbar: { randomCardToTop: true, zoom: true, navigation: true }, hideTokensOnFront: true }} />;
                break;
            case PlayerComponent.Deck:
                component = <DeckComponent key={2} deck={this.props.state.deck}
                    horizontal={false}
                    onChanged={() => this.props.onChanged()}
                    settings={{ draggable: true, toolbar: { shuffle: true, navigation: true, edit: true } }}
                />;
                break;
            case PlayerComponent.Discard:
                component = <DeckComponent key={3} deck={this.props.state.discard}
                    horizontal={false}
                    settings={{ draggable: true, toolbar: { zoom: true, navigation: true } }}
                    onChanged={() => this.props.onChanged()} />;
                break;
            case PlayerComponent.InPlay:
                component = <InvestigatorHandComponent key={4} deck={this.props.state.inPlay}
                    settings={{ toolbar: { exhaust: true, zoom: true, navigation: true } }}
                    onChanged={() => this.props.onChanged()} />;
                break;
            case PlayerComponent.Threat:
                component = <InvestigatorHandComponent key={5} deck={this.props.state.threat} settings={{ toolbar: { exhaust: true, zoom: true, navigation: true } }} onChanged={() => this.props.onChanged()} />;
                break;
        }
        return (
            <div id="player-navigator">
                <div>
                    <ul className="active-selector">
                        <PlayerNavigatorMenuItemComponent title="Deck" playerComponent={PlayerComponent.Deck} state={this.props.state} onChanged={() => this.props.onChanged()} />
                        <PlayerNavigatorMenuItemComponent title="Hand" playerComponent={PlayerComponent.Hand} state={this.props.state} onChanged={() => this.props.onChanged()} />
                        <PlayerNavigatorMenuItemComponent title="In Play" playerComponent={PlayerComponent.InPlay} state={this.props.state} onChanged={() => this.props.onChanged()} />
                        <PlayerNavigatorMenuItemComponent title="Threat" playerComponent={PlayerComponent.Threat} state={this.props.state} onChanged={() => this.props.onChanged()} />
                        <PlayerNavigatorMenuItemComponent title="Discard" playerComponent={PlayerComponent.Discard} state={this.props.state} onChanged={() => this.props.onChanged()} />
                    </ul>
                </div>
                {component}
            </div>
        );
    }

}
